import React from 'react';
import { Route } from 'react-router';

import AppSettingsUI from './AppSettings';
import enhance from './AppSettingsContainer';

const AppSettings = enhance(AppSettingsUI);

const PublicRoutes = () => (
  <Route path="/app-settings" component={AppSettings} />
);

export default PublicRoutes;
